import React from "react";

function AuditLogs() {
  return <div>AuditLogs</div>;
}

export default AuditLogs;
